// @flow

import type { Merchant, MerchantConfig } from './types';

export function getMerchantConfig(merchant: Merchant): ?MerchantConfig {
  return merchant['config'];
}
